import React from 'react';
import classNames from 'classnames';
import { Image, ImageOverlay } from 'seduo-ui';
const SkeletonImage = ({ theme, width, height, alt, className, wrapperClassName }) => {
    return (<ImageOverlay className={wrapperClassName}>
            <Image src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" width={width} height={height} alt={alt} className={classNames('skeleton', { 'skeleton--dark': theme === 'dark' }, className)}/>
        </ImageOverlay>);
};
SkeletonImage.defaultProps = {
    theme: 'light',
};
export default SkeletonImage;
